import { Injectable, inject } from '@angular/core';
import {
  ActionLogApiService,
  ApiActionLogListResponseDto,
} from '@birco/rainmesh-api';
import { Observable } from 'rxjs';
import { ActionLogStateService } from '../api/action-log-state-service.interface';
import { ActionLogFilter } from '../../../features/action-log/state/action-log.state';

@Injectable({
  providedIn: 'root',
})
export class ActionLogStateServiceImpl implements ActionLogStateService {
  private actionLogApiService = inject(ActionLogApiService);

  getActionLog(
    options: ActionLogFilter,
  ): Observable<ApiActionLogListResponseDto> {
    return this.actionLogApiService.getActionLog(
      options.pageSize,
      options.page,
      options.sortBy,
      options.sortDir,
      options.searchTerm,
      this.toIsoDateString(options.startDate),
      this.toIsoDateString(options.endDate),
      options.actions,
      options.triggers,
      options.result ? [options.result] : undefined,
      options.objectTypes,
      options.userEmail,
    );
  }

  private toIsoDateString(date?: string): string | undefined {
    return date ? new Date(date).toISOString() : undefined;
  }
}
